import {
  MASTERCRONSCHEDULE_LIST_OVERDUE,
  MASTERCRONSCHEDULE_LIST_OVERDUE_SUCCESS,
  MASTERCRONSCHEDULE_LIST_OVERDUE_FAILURE,
  MASTERCRONSCHEDULE_LIST,
  MASTERCRONSCHEDULE_LIST_SUCCESS,
  MASTERCRONSCHEDULE_LIST_FAILURE,
  MASTERCRONSCHEDULE_REQUESTRUN,
  MASTERCRONSCHEDULE_REQUESTRUN_SUCCESS,
  MASTERCRONSCHEDULE_REQUESTRUN_FAILURE,
} from "./actionType";

//Actions
///mastercronschedule/list/overdue
export const masterCronScheduleListOverdue = (payload) => ({
  type: MASTERCRONSCHEDULE_LIST_OVERDUE,
  payload,
});

export const masterCronScheduleListOverdueSuccess = (payload) => ({
  type: MASTERCRONSCHEDULE_LIST_OVERDUE_SUCCESS,
  payload,
});

export const masterCronScheduleListOverdueFailure = (error) => ({
  type: MASTERCRONSCHEDULE_LIST_OVERDUE_FAILURE,
  error,
});

///mastercronschedule/list
export const masterCronScheduleList = (payload) => ({
  type: MASTERCRONSCHEDULE_LIST,
  payload,
});

export const masterCronScheduleListSuccess = (payload) => ({
  type: MASTERCRONSCHEDULE_LIST_SUCCESS,
  payload,
});

export const masterCronScheduleListFailure = (error) => ({
  type: MASTERCRONSCHEDULE_LIST_FAILURE,
  error,
});

///mastercronschedule/requestrerun/166
export const masterCronScheduleRequestRun = (payload) => ({
  type: MASTERCRONSCHEDULE_REQUESTRUN,
  payload,
});

export const masterCronScheduleRequestRunSuccess = (payload) => ({
  type: MASTERCRONSCHEDULE_REQUESTRUN_SUCCESS,
  payload,
});

export const masterCronScheduleRequestRunFailure = (error) => ({
  type: MASTERCRONSCHEDULE_REQUESTRUN_FAILURE,
  error,
});
